import React from "react";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import AutorizacionDetail from "./AutorizacionDetail";
import Badge from "../../../../../../components/common/PL/Badge/Badge";
import { AuthorizationGroup } from "./transportAuthorizationTypes";

type TransportCompanionAuthorizationCardProps = {
  autorizacion: AuthorizationGroup;
};

// Static counterpart of the driver's own AutorizacionesList card: same header markup,
// no click/expand affordances since it's purely informational for the companion.
const TransportCompanionAuthorizationCard: React.FC<TransportCompanionAuthorizationCardProps> = ({
  autorizacion: auth,
}) => (
  <div className="transportAuthCard">
    <div className="transportAuthCardHeaderArea">
      <div className="transportAuthCardTop">
        <div className="transportAuthCardTitleGroup">
          <div className="transportAuthTitleBlock">
            <h4 className="transportAuthCardTitle">{auth.title}</h4>
            {auth.subtitle && <span className="transportAuthCardSubtitle">{auth.subtitle}</span>}
          </div>
          <div className="transportPillRow">
            {auth.operationLabels.map((label) => (
              <Badge key={label} variant={label === "Descarga" ? "yellow" : "blue"} label={label} />
            ))}
          </div>
        </div>
        <div className="transportAuthCardRight">
          <span className="transportLugaresDispCapsule">
            {auth.availableSlots} {auth.availableSlots === 1 ? "lugar disp." : "lugares disp."}
          </span>
        </div>
      </div>
      <div className="transportAuthCardBottom">
        <LocalShippingOutlinedIcon fontSize="small" style={{ color: "#94A3B8" }} />
        <span className="transportAuthCardMetaText">
          {auth.usedTrucks}/{auth.totalTrucks} camiones &nbsp;|&nbsp; {auth.authorizerCount}{" "}
          autorizadores
          {auth.dock !== undefined && <>&nbsp;|&nbsp;Número de dock: {auth.dock}</>}
        </span>
      </div>
    </div>

    <AutorizacionDetail
      group={auth}
      selectedRowId={auth.rows[0]?.id ?? null}
      onSelectRow={() => {}}
      onResendRow={() => {}}
      disabled
    />
  </div>
);

export default TransportCompanionAuthorizationCard;
